import { doMutation } from "../../core-module/util/graphqlHelper";

export const importEmployees = inputs => {
  const mutation = require("../api/mutation/importEmployees.gql");
  const variables = { inputs };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      location.reload();
      return { data: data.importEmployees };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
